import { PerformanceAccountsQuery } from '../../graphql/performanceAccounts.generated';

export type AccountsFilterProps = {
  accounts: PerformanceAccountsQuery['performance']['accounts'];
};

export const AccountsFilter: React.FC<AccountsFilterProps> = ({ accounts }) => {
  if (accounts.length === 0) {
    return null;
  }

  return (
    <div>
      <div>{accounts.length} accounts</div>
    </div>
  );
};
